import { getJson } from "../../auth/utils/getJson.js";
/** GET /api/filelogs/export/logs (no params) */
export function fetchExportLogs(_dateRange, signal) {
  return getJson(`/api/filelogs/export/logs`, { signal })
    .then((json) => (Array.isArray(json) ? json : []));
}
